import { ISearchProvider, ISearchResult } from "../../../../ui/components-lit/GlobalSearch/types";
import { TGlobalSearchProviderContext } from "./provider.types";

export const createFinanzasProviders = (ctx: TGlobalSearchProviderContext): ISearchProvider[] => {

    // #region Catálogos de finanzas

    const finanzasCatalogoMetodosPagoProvider: ISearchProvider = {
        key: "finanzas-catalogo-metodos-pago",
        label: "Finanzas: Catálogo de métodos de pago",
        subLabel: "Gestión de métodos de pago",
        action: ctx.navigateModule("finanzas/catalogos/metodospago"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasCatalogoIngresosProvider: ISearchProvider = {
        key: "finanzas-catalogo-ingresos",
        label: "Finanzas: Catálogo de ingresos",
        subLabel: "Gestión de plantillas de cargos y descuentos",
        action: ctx.navigateModule("finanzas/catalogos/ingresos"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasCatalogoEgresosProvider: ISearchProvider = {
        key: "finanzas-catalogo-egresos",
        label: "Finanzas: Catálogo de egresos",
        subLabel: "Gestión de plantillas de egresos",
        action: ctx.navigateModule("finanzas/catalogos/egresos"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasCatalogoCuentasProvider: ISearchProvider = {
        key: "finanzas-catalogo-cuentas",
        label: "Finanzas: Catálogo de cuentas",
        subLabel: "Gestión de cuentas financieras, como bancos o cajas de efectivo",
        action: ctx.navigateModule("finanzas/catalogos/cuentas"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasCatalogoProveedoresProvider: ISearchProvider = {
        key: "finanzas-catalogo-proveedores",
        label: "Finanzas: Catálogo de proveedores",
        subLabel: "Gestión de proveedores",
        action: ctx.navigateModule("finanzas/catalogos/proveedores"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasCatalogoCategoriaEgresosProvider: ISearchProvider = {
        key: "finanzas-catalogo-categoria-egresos",
        label: "Finanzas: Catálogo de categorías de egresos",
        subLabel: "Gestión de categorías para egresos",
        action: ctx.navigateModule("finanzas/catalogos/egresoscategorias"),
        search: (): ISearchResult[] => ([]),
    };

    // #region Ingresos

    const finanzasIngresosHorasExtrasProvider: ISearchProvider = {
        key: "finanzas-ingresos-horas-extras",
        label: "Finanzas: Ingresos - Horas extras",
        subLabel: "Gestión de horas extras por alumno",
        action: ctx.navigateModule("finanzas/ingresos/horasextras"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasIngresosPagosRecibidosProvider: ISearchProvider = {
        key: "finanzas-ingresos-pagos-recibidos",
        label: "Finanzas: Ingresos - Pagos recibidos",
        subLabel: "Consulta de pagos recibidos por alumno",
        action: ctx.navigateModule("finanzas/ingresos/pagosrecibidos"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasIngresosPagosPendientesProvider: ISearchProvider = {
        key: "finanzas-ingresos-pagos-pendientes",
        label: "Finanzas: Ingresos - Pagos pendientes",
        subLabel: "Consulta de pagos pendientes por alumno",
        action: ctx.navigateModule("finanzas/ingresos/pagospendientes"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasIngresosCargosPorAplicarProvider: ISearchProvider = {
        key: "finanzas-ingresos-cargos-por-aplicar",
        label: "Finanzas: Ingresos - Cargos por aplicar",
        subLabel: "Consulta de cargos por aplicar por alumno",
        action: ctx.navigateModule("finanzas/ingresos/cargosporaplicar"),
        search: (): ISearchResult[] => ([]),
    };

    // #region Egresos

    const finanzasEgresosCuentasPorPagarProvider: ISearchProvider = {
        key: "finanzas-egresos-cuentas-por-pagar",
        label: "Finanzas: Egresos - Cuentas por pagar",
        subLabel: "Consulta de cuentas por pagar a proveedores",
        action: ctx.navigateModule("finanzas/egresos/cuentasporpagar"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasEgresosMovimientosProvider: ISearchProvider = {
        key: "finanzas-egresos-movimientos",
        label: "Finanzas: Egresos - Movimientos",
        subLabel: "Consulta de movimientos de egresos",
        action: ctx.navigateModule("finanzas/egresos/movimientos"),
        search: (): ISearchResult[] => ([]),
    };

    const finanzasEgresosMovimientosPorProveedorProvider: ISearchProvider = {
        key: "finanzas-egresos-movimientos-por-proveedor",
        label: "Finanzas: Egresos - Movimientos por proveedor",
        subLabel: "Consulta de movimientos de egresos por proveedor",
        action: ctx.navigateModule("finanzas/egresos/movimientosproveedor"),
        search: (): ISearchResult[] => ([]),
    };

    return [
        // Catálogos de finanzas
        finanzasCatalogoMetodosPagoProvider,
        finanzasCatalogoIngresosProvider,
        finanzasCatalogoEgresosProvider,
        finanzasCatalogoCuentasProvider,
        finanzasCatalogoProveedoresProvider,
        finanzasCatalogoCategoriaEgresosProvider,
        // Ingresos
        finanzasIngresosHorasExtrasProvider,
        finanzasIngresosPagosRecibidosProvider,
        finanzasIngresosPagosPendientesProvider,
        finanzasIngresosCargosPorAplicarProvider,
        // Egresos
        finanzasEgresosCuentasPorPagarProvider,
        finanzasEgresosMovimientosProvider,
        finanzasEgresosMovimientosPorProveedorProvider,
    ];
};
